import { render } from "./RecordView.vue?vue&type=template&id=75551f85&scoped=true"
import script from "./RecordView.vue?vue&type=script&lang=js"
export * from "./RecordView.vue?vue&type=script&lang=js"

import "./RecordView.vue?vue&type=style&index=0&id=75551f85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75551f85"]])

export default __exports__